import React, {Component} from 'react';
import Artist from './component/Artist';
import Track from './component/Track';
import Search from './component/Search';


const API_ADDRESS = 'https://spotify-api-wrapper.appspot.com';

class App  extends Component {

  state = { artist : null ,tracks : []};
  

  componentDidMount(){

    this.searchArtist('A R Rehman');


  }

  searchArtist = artistQuery => {
    fetch(`${API_ADDRESS}/artist/${artistQuery}`)
    .then(response => response.json())
    .then(json => {
      console.log(json);

      if(json.artists.total > 0 ){
        const artist = json.artists.items[0]

        this.setState({artist});

        //api to call top tracks (nested)

        fetch(`${API_ADDRESS}/artist/${artist.id}/top-tracks`)
        .then(response => response.json())
        .then(json => {
          console.log(json.tracks);
          this.setState({tracks :json.tracks}); 
        })
        .catch(error => alert(error.message));
    } 
      }).catch(err => console.log(err));
  }
  

  render(){
    return(
      <div className="container">
          <div className="row">
              <div className="col-md-12 jumbotron">
                <h1 className="text-center" > Music player (spotify API) </h1>
              </div>
           </div>   
              <div className="row">
                <Search search={this.searchArtist}/>
                <Artist artist={this.state.artist}/>
                <Track tracks={this.state.tracks} />
              </div>
      </div>
    );
  }
}

export default App;